import type {z} from "zod";

import {EditRepresentativeCommissionBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {commissionFieldLabelIds} from "../../../../../messages/representative-commission.messages";

export const editRepresentativeCommissionNameSchema = requiredStringSchema(
  EditRepresentativeCommissionBody.shape.name,
  commissionFieldLabelIds.name,
);
export const editRepresentativeCommissionPercentageSchema =
  EditRepresentativeCommissionBody.shape.percentage;

export const editRepresentativeCommissionFormSchema = EditRepresentativeCommissionBody.extend({
  name: editRepresentativeCommissionNameSchema,
});
export type EditRepresentativeCommissionFormPayload = z.output<
  typeof editRepresentativeCommissionFormSchema
>;

export const draftEditRepresentativeCommissionFormSchema =
  editRepresentativeCommissionFormSchema.partial();
export type DraftEditRepresentativeCommissionFormPayload = z.output<
  typeof draftEditRepresentativeCommissionFormSchema
>;
